export const SwToMainBroadcastMessageTypes = {
    ACTIVATION: 'ACTIVATION',
    PONG: 'PONG',
    STREAM_CANCELLED: 'STREAM_CANCELLED',
};
export const MainToSwBroadcastMessageTypes = {
    PING: 'PING',
    ERROR: 'ERROR',
};
